// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.not-found_wrapper__qJaTg {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
  padding: 48px;
}

.not-found_image__mTqvi {
  max-width: 500px;
  width: 100%;
}

.not-found_content__ANAlW {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 500px;
}

.not-found_title__ZIphX {
  padding: 0 32px;
}

.not-found_description__YQoXN {
  padding: 0 16px;
}

@media (max-width: 768px) {
  .not-found_wrapper__qJaTg {
    padding: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/functional/not-found.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n  padding: 48px;\n}\n\n.image {\n  max-width: 500px;\n  width: 100%;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  max-width: 500px;\n}\n\n.title {\n  padding: 0 32px;\n}\n\n.description {\n  padding: 0 16px;\n}\n\n@media (max-width: 768px) {\n  .wrapper {\n    padding: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `not-found_wrapper__qJaTg`,
	"image": `not-found_image__mTqvi`,
	"content": `not-found_content__ANAlW`,
	"title": `not-found_title__ZIphX`,
	"description": `not-found_description__YQoXN`
};
export default ___CSS_LOADER_EXPORT___;
